export default __webpack_public_path__ + "locales/sl/DeleteDialog.json?hash=2417df043c6fb160b9112d2648538332";